import type { RobotModule } from '@/models/Robot';
import HealthIndicatorEnum from '@/enums/HealthIndicatorEnum';
import type { RobotCompositionModule } from '@/models/RobotCompositionModule';
import type { SoftwareVersions } from '@/models/SoftwareVersions';
import { EMPTY_SOFTWARE_VERSIONS } from '@/models/SoftwareVersions';

export interface RobotDetails {
  uuid: string;
  overallHealthIndicator: number;
  modules: RobotModule[];
  robotComposition: RobotCompositionModule[];
  softwareVersions: SoftwareVersions;
  onlineState: boolean | null;
  lastSeen: string;
  ipAddress: string;
  grafanaLink: string;
  name: string;
  serialNumber: string;
}

export const EMPTY_ROBOT_DETAILS: RobotDetails = {
  uuid: '',
  onlineState: null,
  lastSeen: '',
  overallHealthIndicator: HealthIndicatorEnum.UNKNOWN,
  modules: [],
  robotComposition: [],
  softwareVersions: EMPTY_SOFTWARE_VERSIONS,
  ipAddress: '',
  grafanaLink: '',
  name: '',
  serialNumber: '',
};
